import React from 'react';
import './BroadcastAnchor.less';

export default ({ className, ...rest }) => (
  <div className={`broadcast-anchor ${className || ''}`} {...rest} />
);
